module.exports = __webpack_public_path__ + "static/media/login_left.af85f941.png";